import React, { useState } from "react";
import { ListItem, ListItemText, List, Divider, Stack, Button, Typography } from '@mui/material';


const NhtsaHeader = (props) => {

    var { recallsCount, complaintsCount, investigationsCount, communicationsCount, setTab, tab } = props;


    return (

        <List
            sx={{
                p: 0,
                width: '100%',
                marginBottom: 2,
                border: '1px solid',
                borderColor: 'divider',
                backgroundColor: 'background.paper',
            }}
        >


            <ListItem>
                <Button
                    sx={{
                        width: "100%",
                        margin: "5px"
                    }}
                    variant={tab === 'recalls' ? "contained" : "outlined"}
                    color={tab === 'recalls' ? "warning" : "primary"}
                    onClick={() => setTab('recalls')}
                >
                    {`Recalls (${recallsCount || 0})`}
                </Button>
                <Button
                    sx={{
                        width: "100%",
                        margin: "5px"
                    }}
                    variant={tab === 'complaints' ? "contained" : "outlined"}
                    color={tab === 'complaints' ? "warning" : "primary"}
                    onClick={() => setTab('complaints')}
                >
                    {`Complaints (${complaintsCount || 0})`}
                </Button>
                <Button
                    sx={{
                        width: "100%",
                        margin: "5px"
                    }}
                    variant={tab === 'investigations' ? "contained" : "outlined"}
                    color={tab === 'investigations' ? "warning" : "primary"}
                    onClick={() => setTab('investigations')}
                >
                    {`Investigations (${investigationsCount || 0})`}
                </Button>
                <Button
                    sx={{
                        width: "100%",
                        margin: "5px"
                    }}
                    variant={tab === 'communications' ? "contained" : "outlined"}
                    color={tab === 'communications' ? "warning" : "primary"}
                    onClick={() => setTab('communications')}
                >
                    {`communications (${communicationsCount || 0})`}
                </Button>
            </ListItem>


            <Divider variant="middle" flexItem />
            {tab === "TIRE recalls" ? <React.Fragment>
                <Stack display={'flex'} direction={'row'} justifyContent={'space-between'} alignItems={'center'} sx={{ margin: "10px" }}>
                    <Typography variant="h6" color="warning" sx={{ marginLeft: "10px" }}>Recalls</Typography>
                    {/* <Button variant="outlined" color="warning">Add Recalls</Button>  */}
                </Stack>

            </React.Fragment> : ''}

            {tab === "complaints" ? <React.Fragment>
                <Stack display={'flex'} direction={'row'} justifyContent={'space-between'} alignItems={'center'} sx={{ margin: "10px" }}>
                    <Typography variant="h6" color="warning" sx={{ marginLeft: "10px" }}>Complaints</Typography>
                    {/* <Button variant="outlined" color="warning">Add Complaints</Button>  */}
                </Stack>

            </React.Fragment> : ''}

            {tab === "investigations" ? <React.Fragment>
                <Stack display={'flex'} direction={'row'} justifyContent={'space-between'} alignItems={'center'} sx={{ margin: "10px" }}>
                    <Typography variant="h6" color="warning" sx={{ marginLeft: "10px" }}>Investigations</Typography>
                    {/* <Button variant="outlined" color="warning">Add Investigations</Button>  */}
                </Stack>

            </React.Fragment> : ''}

            {tab === "communications" ? <React.Fragment>
                <Stack display={'flex'} direction={'row'} justifyContent={'space-between'} alignItems={'center'} sx={{ margin: "10px" }}>
                    <Typography variant="h6" color="warning" sx={{ marginLeft: "10px" }}>Communications</Typography>
                    {/* <Button variant="outlined" color="warning">Add Communications</Button>  */}
                </Stack>

            </React.Fragment> : ''}
        </List>

    )
}

export default NhtsaHeader;